module.exports = __webpack_public_path__ + "img/img_food.263bd9a.jpg";